import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import TweenMax from "gsap";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";

export default class FeatureContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.startFeature.add(this.onStart, this)
    Signals.stopFeature.add(this.onStop, this)

    this.activeBullets = []
    this.itemsPool = []

    this.enemy = new SpineAnimation('enemyShip')
    this.addChild(this.enemy)
    this.visible = false
    this.enemy.position.set(253, -200)

    this.laser = new PIXI.Sprite(PIXI.Texture.from('enemyLaser'))
    this.laser.scale.set(0.5, 0.62)
    this.laser.position.set(88, 80)
    this.enemy.addChild(this.laser)
    this.laser.visible = false

  }


  onStart() {
    Facade.soundManager.play('space_warning', 0.1, false, 'default')

    this.realStartFeatureTimer = setTimeout(() => {
      this.realStart()
    }, Facade.model.randomTime)
  }

  realStart() {
    this.laser.visible = false
    this.isFeatureStopped = false
    this.visible = true
    Facade.soundManager.play('space_boss_intro', 0.2, false, 'default')
    TweenMax.to(this.enemy, 1, {x: 253, y: 100})
    this.enemy.start(['appearing'], [false])
    this.shootingTimeout = setTimeout(() => {
      Facade.soundManager.stop('space_warning')
      this.shooting()
    }, 500)
    this.isShooting = true
  }

  onRoundEnd() {
    clearTimeout(this.realStartFeatureTimer)
    this.realStartFeatureTimer = null
    Facade.soundManager.stop('space_boss_attack')

    clearTimeout(this.laserTimer)
    this.laser.visible = false
    clearTimeout(this.shootingTimeout)
    clearTimeout(this.winTimeout)
    if(this.isFeatureStopped) {return}
    this.isShooting = false
    this.enemy.start(['idle'], [false])
  }

  onMakeBets() {
    TweenMax.killTweensOf(this.enemy)
    this.enemy.position.set(255, -200)
    this.visible = false
  }

  onStop(currentBonus) {
    clearTimeout(this.realStartFeatureTimer)
    this.realStartFeatureTimer = null

    Facade.soundManager.stop('space_boss_attack')

    if(this.isFeatureStopped) {
      return
    }
    this.isFeatureStopped = true

    let animation = 'explosionEnemy'

    if(currentBonus.tp == "multiplier" && currentBonus.v == 1) {
      animation = 'escapeBattle'
    }

    if(animation == 'escapeBattle') {
      Facade.soundManager.play('space_boss_win_glitter', 0.1, false, 'default')
    } else {
      Facade.soundManager.play('space_boss_win', 0.1, false, 'default')
    }

    this.enemy.start([animation], [false])

    this.winTimeout = setTimeout(() => {
      TweenMax.killTweensOf(this.enemy)
      this.enemy.position.set(255, -200)
      this.visible = false
    }, 2500)

    this.isShooting = false

    this.laser.visible = false

    this.activeBullets.length = 0
  }

  shooting() {
    this.enemy.start(['wingsOpen', 'fireModeIn', 'fireModeLoop'], [false, false, true])

    this.laserTimer = setTimeout(() => {
      this.laser.visible = true
      Facade.soundManager.play('space_boss_attack', 0.1, true, 'default')
    }, 2000)
  }


}
